import { render } from "./FormCavityWallCameraInspectionView.vue?vue&type=template&id=2a5fc284"
import script from "./FormCavityWallCameraInspectionView.vue?vue&type=script&lang=js"
export * from "./FormCavityWallCameraInspectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__